import React, { Component } from 'react';
import { Card, Avatar, message, Icon, Breadcrumb } from 'antd';
import { Redirect } from 'react-router-dom';
import PublicMenu from '../../components/TopMenu';
import axios from 'axios';
import Configuration from '../../Configuration';
const { Meta } = Card;

class Video extends Component {
  constructor() {
    super();
    this.schema = {body: '', video_id: 1};
    this.headers = {Authorization: localStorage.getItem('visitapp:token')};
    this.state = {redirect: false, video: {title: '', body: '', video: '', status: true}};
    this.validateToken = this.validateToken.bind(this);
    this.getVideo = this.getVideo.bind(this);
  }

  componentDidMount() {
    this.validateToken();
    this.getVideo();
  }

  validateToken() {
    if(!localStorage.getItem('visitapp:token'))
      this.setState({redirect: true});
    
    if(!Configuration.isInRol(localStorage.getItem('visitapp:rol'), "admin or gerente or empleado or guardia"))
      this.setState({redirect: true});
  }

  getVideo() {
    const id = this.props.match.params.id;

    axios.get(`${Configuration.apiServer}/api/v1/videos/${id}`, {headers: this.headers}).then(resp => {
      if(resp.status !== 200)
        return message.warning('Hubo un error al procesar los datos')
      
      if(resp.data.status === 'error')
        return message.warning('Petición inválida')

      this.setState({video: resp.data});
    });
  }
  
  render() {
    // Verify authentication
    if(this.state.redirect) {
      return (
        <Redirect to="/" />
      );
    }

    // Render component
    return (
      <div>
        <PublicMenu />
        
        <div className="container" style={{ marginTop: '30px' }}>
          <div className="d-flex flex-row flex-start">
            <Breadcrumb>
              <Breadcrumb.Item> <a href="/support/videos">Videos</a> </Breadcrumb.Item>
              <Breadcrumb.Item>{this.state.video.title}</Breadcrumb.Item>
            </Breadcrumb>
          </div>

          <br/>

          <div className="d-flex flex-row flex-wrap justify-content-between">
            <div style={{ width: '30%', padding: '0px 10px' }}>
              <br/>

              <Card
                style={{ width: '100%', margin: '0px' }}
              >
                <Meta
                  avatar={<Avatar icon="solution" />}
                  title={this.state.video.title}
                />
                <p className="text-muted" style={{ marginTop: '15px', marginLeft: '45px' }}>
                  <Icon type="calendar" /> { Configuration.formatDate(this.state.video.created_at) }
                </p>
                <p className="text-muted" style={{ marginTop: '15px', marginLeft: '45px' }}>
                  {this.state.video.body}
                </p>
              </Card>
            </div>

            <div style={{ width: '70%', padding: '0px 10px' }}>
              <video src={`/imgs/videos/${this.state.video.video}.mp4`} width="100%" ype="video/mp4" controls /> 
            </div>
          </div>
        </div>

      </div>
    );
  }
}

export default Video;



// WEBPACK FOOTER //
// ./src/pages/public/Video.js